var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgError = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M10.088 1.672c4.6 0 8.333 3.733 8.333 8.333s-3.733 8.333-8.333 8.333a8.336 8.336 0 0 1-8.333-8.333c0-4.6 3.733-8.333 8.333-8.333m-.833 12.5h1.666v-1.667H9.255zm0-3.334h1.666v-5H9.255z"
  })));
};
export default SvgError;